<template>
      <div>
      <div class="barra">
              <div class="logo">
                  <img src="@/assets/logo.png"/>
              </div>
      </div>
      <div class="cesta"> 
        <div class="continuar" @click="retornar">
          <div class="retornar">
            <mdi-retornar></mdi-retornar>
          </div>
          <div class="titcontinuar">CONTINUAR COMPRANDO</div>
        </div>
        <div class="titulo">SUA CESTA</div>

        <div class="cabecalho">
          <div class="linhas">
            <!-- <div class="cab-1">
            <div class="imagem">-</div>
            <div class="descricao">ARTIGO | COR</div> -->
            <!-- </div> -->
            <div class="cab-2">

            <!-- <div class="preco">PREÇO</div>
            <div class="metragem">METRAGEM</div>
            <div class="valor">VALOR (R$)</div> -->
            </div>
          </div>
        </div>
        <div class="carrinho">
          <div v-for="a in artigos" v-bind:key="a.codreferencia">
            <div class="item-cesta">
                <div class="imagem">
                  <img :src="'' + a.imagem + ''"/>
                </div>
                <div class="linhas">
                  <div class="item-cesta-1">
                          <div class="descricao">{{a.descricao}}</div>
                          <div class="cor">{{a.cor}}</div>
                  </div>
                  <div class="item-cesta-2">
                          <div class="preco">{{a.precoformatado}}</div>
                          <div class="metragem">
                            <input  class="quantidade" type="text" @keyup="metragemMudou" v-model="a.quantidade"/>
                            <div class="cm">cm</div>
                          </div>
                          <div  class="precocalculado">{{(a.preco * (a.quantidade/100.00)).toLocaleString('pt-br',{'minimumFractionDigits':2, 'maximumFractionDigits':2})}}</div>
                  </div>
                </div>
            </div>
          </div>
        </div>
        <div class="totais">
          <div class="titulo">TOTAL: </div>
          <div  class="valor">R$ {{valortotalformatado}}</div>
        </div>
        
        <div class="continuar2" @click="retornar">
          <div class="retornar">
            <mdi-retornar></mdi-retornar>
          </div>
          <div class="titcontinuar">CONTINUAR COMPRANDO</div>
        </div>
      </div>
      <rodape></rodape>
    </div>

</template>
<style lang="scss" scoped>
  @import "@/assets/scss/cesta.scss";
</style>
<script>
 import g from '@/softam/geral'

import Rodape from '../components/rodape.vue'

export default {
  components:{
    'rodape': Rodape,
  },
  data: function(){

    return {
      artigos: null,
      quantidade: 99.99,
      apagar: 0,
      valortotal: 0,
      valortotalformatado:"0,00",
    }

  },
  methods:{

    metragemMudou: function(){
      console.log("metragemmudou");
      var apagar = 0;
      var valortotal =0;
      for (var i=0;i<this.artigos.length;i++){
        apagar = this.artigos[i].preco * (this.artigos[i].quantidade/100.0);
        valortotal += apagar;
      }
      this.valortotalformatado = g.formatarF(valortotal);
    },

    retornar(){
      this.$router.push("/");

    },
  },
  created(){
      this.artigos = this.$store.getters.cestaRecuperar;
      var valortotal = 0;
      var apagar = 0;
      for (var i=0;i<this.artigos.length;i++){
        apagar = this.artigos[i].preco * (this.artigos[i].quantidade/100.0);
        this.artigos[i].apagar = g.formatarF(apagar);
        this.artigos[i].precoformatado = g.formatarF(this.artigos[i].preco);
        valortotal += apagar;
        console.log(apagar);
      }
      this.valortotalformatado = 0;
      this.valortotalformatado = g.formatarF(valortotal);
  },
  mounted(){

        let viewheight = window.outerHeight;
        let viewwidth = window.outerWidth;
        let viewport = document.querySelector("meta[name=viewport]");
        viewport.setAttribute("content", "height=" + viewheight + "px, width=" + viewwidth + "px, initial-scale=1.0");
    
  }
}
</script>